<template>
  <div class="disclaimer-container" v-if="displayDisclaimer">
    <v-container class="px-sm-7 pt-6">
      <sc-rich-text :field="this.fields.DisclaimerText" :editable="false" />
    </v-container>
  </div>
</template>

<script>
import { RichText } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'FooterDisclaimer',
  data() {
    return {};
  },
  props: {
    fields: {
      type: Object,
      default: () => ({
        DisclaimerText: {},
      }),
    },
  },
  computed: {
    displayDisclaimer(){
      // No Datasource
      if(this.fields.DisclaimerText === null || typeof(this.fields.DisclaimerText)==='undefined'){
        return false;
      }

      // Field has a value - display
      if(this.fields.DisclaimerText.value && this.fields.DisclaimerText.value !== ''){
        return true;
      }

      return false;
    }
  },
  components: {
    ScRichText: RichText,
  },
};
</script>
<style lang="scss" scoped>
.disclaimer-container {
  border-bottom: 1px solid map-deep-get($colors, 'grey-dark', 'base');
  font-size: 13px;
  font-weight: map-get($font-weights, 'normal');

  &::v-deep {
    a {
      color: map-deep-get($colors, 'white', 'base')
    }
  }
}
</style>
